import { useEffect, useState } from 'react';

// 简单弹框组件
export function Modal({ visible, onClose, onConfirm, message }) {
  if (!visible) return null;

  const createButton = (text, color, onClick) => {
    return (
      <button
        onClick={onClick}
        style={{
          backgroundColor: color,
          color: 'white',
          border: 'none',
          padding: '10px 30px',
          borderRadius: '4px',
          fontSize: '14px',
          cursor: 'pointer'
        }}
      >
        {text}
      </button>
    )
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 3
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          padding: '30px',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
          minWidth: '250px',
          textAlign: 'center',

        }}
      >
        <p style={{
          margin: '0 0 20px 0',
          fontSize: '20px',
          color: '#333'
        }}>
          {message}
        </p>

        <div style={{
          display: 'flex',
          justifyContent: 'flex-start',
        }}>
          {onClose ? createButton('取消', 'red', onClose) : ''}
          {onConfirm ? createButton('确定', 'green', onConfirm) : ''}
        </div>
      </div>
    </div>
  );
};

export function compressImageToBase64(file, maxWidth = 800, quality = 0.8) {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.onload = () => {
      try {
        // 计算压缩后的尺寸
        let { width, height } = img;

        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }

        // 设置画布尺寸
        canvas.width = width;
        canvas.height = height;

        // 绘制压缩后的图片
        ctx.drawImage(img, 0, 0, width, height);

        // 转换为 Base64
        const base64 = canvas.toDataURL('image/jpeg', quality);

        // 计算压缩后的大小（Base64 字符串的字节大小）
        const base64Size = Math.round((base64.length * 3) / 4);

        resolve({
          base64: base64,
          size: base64Size,
          originalSize: file.size,
          width: width,
          height: height,
          compressionRatio: ((file.size - base64Size) / file.size * 100).toFixed(2)
        });

      } catch (error) {
        reject(error);
      }
    };

    img.onerror = () => {
      reject(new Error('图片加载失败'));
    };

    img.src = URL.createObjectURL(file);
  });
};

export function formatTime(dateTimeString) {
  const date = new Date(dateTimeString);
  return date.toLocaleTimeString('zh-CN', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
}

// 简单的 Toast 提示组件
export const Toast = ({ message, visible, onClose, duration = 1000 }) => {
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [visible, duration, onClose]);

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '30%',                     // 距离顶部30%（中间偏上）
        left: '50%',                    // 水平居中
        transform: 'translateX(-50%)',  // 水平居中对齐
        backgroundColor: '#333',
        color: 'white',
        padding: '12px 20px',
        borderRadius: '6px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
        zIndex: 9999,
        fontSize: '14px',
        maxWidth: '300px',
        wordWrap: 'break-word',
        animation: 'fadeIn 0.3s ease-out'
      }}
    >
      {message}

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

/// 获取指纹并上传
export function getFingerprintSetting(onRecv, onError) {
  if (window.location.hostname === '127.0.0.1') {
    return;
  }
  let newTime = new Date().getTime();
  try {
    const fpPromise = import('https://fpjscdn.net/v3/ezaeEyVaxY4eCbqIM1sV?time=' + newTime)
      .then(
        FingerprintJS => FingerprintJS.load(
          {
            endpoint: [
              'https://figer.dogdata.top/result',
              FingerprintJS.defaultEndpoint
            ],
            scriptUrlPattern: [
              'https://figer.dogdata.top/js?version=<version>&apiKey=<apiKey>&loaderVersion=<loaderVersion>',
              FingerprintJS.defaultScriptUrlPattern,
            ],
          }
        ));
    fpPromise
      .then(fp => fp.get({ extendedResult: true }))
      .then(result => {
        StorageUtils.set("fingerPrintLocationTime", {
          visitorId: result.visitorId,
          time: newTime,
        });
        onRecv(result.visitorId, JSON.stringify(result.ipLocation));
      })
      .catch((error) => {
        onError("获取指纹请求异常: " + error);
      });
  } catch (e) {
    onError("获取指纹执行: " + e);
  }
}

const StorageUtils = {
  set(name, value) {
    sessionStorage.setItem(name, JSON.stringify(value));
  },
  get(name) {
    if (!!sessionStorage.getItem(name) && sessionStorage.getItem(name) !== "undefined") {
      return JSON.parse(sessionStorage.getItem(name));
    } else {
      return null;
    }
  }
}

// 自定义Hook来管理plib
export function usePlib() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (window.plib) {
      setIsLoaded(true);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://resource.dogdata.work/plib.js';
    script.async = true;

    script.onload = () => {
      setIsLoaded(true);
    };

    script.onerror = () => {
      setError('Failed to load plib');
    };

    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return { isLoaded, error, plib: window.plib };
}